import { render, staticRenderFns } from "./sub_report.vue?vue&type=template&id=a5fc8094&scoped=true"
import script from "./sub_report.vue?vue&type=script&lang=js"
export * from "./sub_report.vue?vue&type=script&lang=js"
import style0 from "./sub_report.vue?vue&type=style&index=0&id=a5fc8094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fc8094",
  null
  
)

export default component.exports